import axiosInstance from '@/app/api/axiosInstance';
import { AccountGroupCreate, AccountGroupUpdate, AccountGroupResponse } from '@/app/types';
import { PaginatedResponse, ListQueryParams } from '@/app/types/api';

export const listAccountGroups = async (
  params: ListQueryParams & {
    parent_id?: number | null;
    hierarchical?: boolean;
  },
  organizationId?: number
): Promise<PaginatedResponse<AccountGroupResponse>> => {
  try {
    const requestParams = {
      ...params,
      ...(params.filters && typeof params.filters === 'string'
        ? { filters: params.filters }
        : organizationId 
            ? { filters: JSON.stringify({ organization_id: organizationId }) }
            : {})
    };

    const response = await axiosInstance.get<PaginatedResponse<AccountGroupResponse>>(
      '/account-groups/', 
      { params: requestParams }
    );
    
    return response.data;
  } catch (error) {
    console.error('Failed to list account groups:', error);
    throw error;
  }
};

export const getAccountGroup = async (accountGroupId: number): Promise<AccountGroupResponse> => {
  try {
    const response = await axiosInstance.get<AccountGroupResponse>(`/account-groups/${accountGroupId}`);
    return response.data;
  } catch (error) {
    console.error(`Failed to get account group with ID ${accountGroupId}:`, error);
    throw error;
  }
};

export const createAccountGroup = async (
  data: AccountGroupCreate, 
  organizationId?: number
): Promise<AccountGroupResponse> => {
  try {
    const accountGroupData = {
      ...data,
      ...(organizationId ? { organization_id: organizationId } : {})
    };
    
    const response = await axiosInstance.post<AccountGroupResponse>('/account-groups/', accountGroupData);
    return response.data;
  } catch (error) {
    console.error('Failed to create account group:', error);
    throw error;
  }
};

export const updateAccountGroup = async (
  accountGroupId: number, 
  data: AccountGroupUpdate
): Promise<AccountGroupResponse> => {
  try {
    const response = await axiosInstance.patch<AccountGroupResponse>(
      `/account-groups/${accountGroupId}`, 
      data
    );
    return response.data;
  } catch (error) {
    console.error(`Failed to update account group with ID ${accountGroupId}:`, error);
    throw error;
  }
};

export const deleteAccountGroup = async (accountGroupId: number): Promise<void> => {
  try {
    await axiosInstance.delete(`/account-groups/${accountGroupId}`);
  } catch (error) {
    console.error(`Failed to delete account group with ID ${accountGroupId}:`, error);
    throw error;
  }
}; 